// ── 4 Modelle ── das Formular: Plattform-Key (Requesty) und/oder eigener
// Endpoint des Kunden, je mit Modell-Picker und „Speichern und prüfen"; dazu
// die Flow-Modelle mit ihrem eigenen Key (flow-models-form.tsx).

import { post } from "../../api/client";
import type { ProbeResult } from "../../api/types";
import { Note } from "../../ui/badge";
import { Check, Field, Input } from "../../ui/field";
import { SelectMenu } from "../../ui/select-menu";
import { FlowModelsSection } from "./flow-models-form";
import { ModelPicker } from "./model-picker";
import { DEFAULT_ENDPOINT, GATEWAY_PRESETS, kindOptions, type ModelsState } from "./models";
import { Probe } from "./probe";
import { fieldError, secretPlaceholder, setter } from "./shared";
import type { StepFormProps } from "./types";

export function ModelsForm({ tenant: t, catalog: cat, state, setState, check, save }: StepFormProps<ModelsState>) {
  const set = setter(setState);
  const err = (k: string) => fieldError(check, k);
  const kinds = kindOptions(cat);
  const gw = cat.platform_gateway;
  const probe = (which: "platform" | "own") => async () => {
    await save();
    return post<ProbeResult>(`/tenants/${t.id}/checks/models`, { which });
  };
  return (
    <>
      <div className="pf-list">
        <div className="pf-integration">
          <div className="pf-integration__head">
            <Check
              name="p_enabled" checked={state.p_enabled} disabled={!gw} onChange={set("p_enabled")}
              label={<strong>Plattform-Key (Requesty)</strong>}
              hint={gw
                ? `Ein eigener Requesty-Key je Mandant mit Monatslimit (${gw.router_url}). Limit erreicht = harte Sperre; abgerechnet wird über Solutec.`
                : "Aus: REQUESTY_MANAGEMENT_KEY fehlt in der Plattform."}
            />
          </div>
          <div className="pf-integration__fields pf-list" hidden={!state.p_enabled}>
            <div className="pf-grid">
              <Field label="Agent"><SelectMenu name="p_kind" value={state.p_kind} options={kinds} onChange={set("p_kind")} /></Field>
              <Field label="Limit je Monat (USD)" error={err("platform.budget_usd")}>
                <Input name="p_budget" type="number" min={1} step={1} value={state.p_budget} invalid={!!err("platform.budget_usd")} onChange={(e) => set("p_budget")(e.target.value)} />
              </Field>
            </div>
            <ModelPicker
              tenantId={t.id} which="platform" allowed={state.p_allowed} defaultModel={state.p_default_model}
              onChange={(allowed, def) => setState((s) => ({ ...s, p_allowed: allowed, p_default_model: def }))}
            />
            {err("platform.enabled") && <Note tone="error">{err("platform.enabled")}</Note>}
            <Probe label="Speichern und Gateway prüfen" outId="probe-p" run={probe("platform")} />
          </div>
        </div>
        <div className="pf-integration">
          <div className="pf-integration__head">
            <Check
              name="o_enabled" checked={state.o_enabled} onChange={set("o_enabled")}
              label={<strong>Eigener Endpoint des Kunden</strong>}
              hint="Jedes OpenAI-kompatible Gateway mit Adresse und Key des Kunden; die Kosten rechnet die Instanz über Preise je Modell."
            />
          </div>
          <div className="pf-integration__fields pf-list" hidden={!state.o_enabled}>
            <div className="pf-grid">
              <Field label="Name" error={err("own.name")}>
                <Input name="o_name" value={state.o_name} invalid={!!err("own.name")} onChange={(e) => set("o_name")(e.target.value)} />
              </Field>
              <Field label="Agent"><SelectMenu name="o_kind" value={state.o_kind} options={kinds} onChange={set("o_kind")} /></Field>
              <Field
                label="Adresse des Gateways" error={err("own.base_url")}
                hint={<>ohne <code>/v1</code> · {GATEWAY_PRESETS.map(([label, url], i) => (
                  <span key={url}>{i > 0 && " · "}<button type="button" className="pf-link" onClick={() => set("o_base_url")(url)}>{label}</button></span>
                ))}</>}
              >
                <Input name="o_base_url" value={state.o_base_url} placeholder="https://…" invalid={!!err("own.base_url")} onChange={(e) => set("o_base_url")(e.target.value)} />
              </Field>
              <Field label="Key" error={err("own.token")}>
                <Input
                  name="o_token" type="password" value={state.o_token} placeholder={secretPlaceholder(t.own_token_set)} invalid={!!err("own.token")}
                  autoComplete="new-password" onChange={(e) => set("o_token")(e.target.value)}
                />
              </Field>
            </div>
            <ModelPicker
              tenantId={t.id} which="own" allowed={state.o_allowed} defaultModel={state.o_default_model}
              onChange={(allowed, def) => setState((s) => ({ ...s, o_allowed: allowed, o_default_model: def }))}
            />
            <Probe label="Speichern und prüfen" outId="probe-o" run={probe("own")} />
          </div>
        </div>
        <FlowModelsSection tenant={t} catalog={cat} state={state} setState={setState} check={check} />
      </div>
      <div className="pf-grid">
        <Field label="Standard-Endpoint" error={err("default")}>
          <SelectMenu name="default" value={state.default} options={DEFAULT_ENDPOINT} onChange={set("default")} />
        </Field>
      </div>
      {err("models") && <Note tone="error">{err("models")}</Note>}
    </>
  );
}
